import { render, staticRenderFns } from "./OldPassword.vue?vue&type=template&id=66a14472&scoped=true&"
import script from "./OldPassword.vue?vue&type=script&lang=js&"
export * from "./OldPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a14472",
  null
  
)

export default component.exports